module.exports = __webpack_public_path__ + "static/media/stationTime.feaad456.svg";